<div class="ribbon-container">
	<div
		*ngFor="let item of menuItems"
		class="ribbon-item"
		[class.active]="activeItem === item.id"
		[matTooltip]="item.label"
		matTooltipPosition="left"
		(click)="onItemClick(item.id)"
	>
		<mat-icon class="ribbon-icon">{{ item.icon }}</mat-icon>

		<div *ngIf="getBadgeCount(item)" class="ribbon-badge">
			{{ getBadgeCount(item) > 99 ? '99+' : getBadgeCount(item) }}
		</div>
	</div>
</div>
